import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Filter} from '@modules/activities/core/activities-search-engine/filter-selector/filter';

@Component({
    selector: 'app-generic-filter-selector',
    templateUrl: './generic-filter-selector.component.html',
    styleUrls: ['./generic-filter-selector.component.scss'],
    standalone: false
})
export class GenericFilterSelectorComponent<T> {
    @Input() public availableFilters: Filter<T>[];
    @Input() public extraContextInfoForAccessibility = ''
    @Output() public filterClick: EventEmitter<Filter<T>> = new EventEmitter<Filter<T>>();

    public onChipClick($event: MouseEvent, filter: Filter<T>): void {
        $event.stopPropagation();
        this.filterClick.emit(filter);
    }
}
